import React, { useMemo } from 'react'
import whatsNew from '../../content/whatsNew.json'

type Props = {
  className?: string
}

type WhatsNewMeta = { buildNumber?: string; frontendVersion?: string }

export function AppVersionText({ className }: Props) {
  const text = useMemo(() => {
    const data = whatsNew as WhatsNewMeta
    const build = data.buildNumber || process.env.REACT_APP_BUILD_VERSION || '0.1'
    const ver = data.frontendVersion || process.env.REACT_APP_VERSION || ''
    const commit = process.env.REACT_APP_GIT_COMMIT
    if (commit && commit !== 'nogit') return `Build ${build} (${commit})`
    if (ver) return `Build ${build} (v${ver})`
    return `Build ${build}`
  }, [])

  return <div className={className}>{text}</div>
}
